var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZenithBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 81,
    viewBox: "0 0 76 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_69_3967)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.678 22.68L7.80903 22.1559L7.94006 21.5007L13.7053 0.798096L75.027 0.929125L7.28491 56.0924L38.2078 18.7491H15.0156L13.7053 18.8801C10.9537 19.0112 8.46417 20.7145 7.678 22.68Z",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7513 38.6654C71.7513 38.4034 69.7859 50.327 66.5102 62.6438L2.43689 63.0369L71.6203 7.0874L40.5664 44.6928H63.8896L65.1999 44.5617C67.9515 44.4307 70.8341 40.6309 71.7513 38.6654Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9538 80.2018H0.0783691L7.54703 69.9815H2.56792L2.96101 67.0989H13.3123L5.84365 77.3192H11.3469L10.9538 80.2018ZM13.0503 80.2018L14.7536 67.0989H22.2223L21.8292 69.9815H17.6363L17.3742 72.209H21.3051L21.043 75.0917H16.9811L16.7191 77.3192H20.912L20.5189 80.2018H13.0503ZM22.7464 80.2018L24.4498 67.0989H27.7255L31.5254 73.9124L31.7874 74.6986L32.3116 76.1399C32.3193 75.3085 32.363 74.4779 32.4426 73.6503L33.2288 67.0989H36.5045L34.8011 80.2018H31.6564L27.8566 73.5193L27.4635 72.6021L26.9394 71.1608C26.9326 72.0358 26.8889 72.9101 26.8083 73.7814L26.0221 80.2018H22.7464ZM37.5527 80.2018L39.2561 67.0989H42.6629L40.9595 80.2018H37.5527ZM45.4145 80.2018L46.7248 70.2436H43.9731L44.3662 67.0989H53.2762L52.8831 70.2436H50.1315L48.8212 80.2018H45.4145ZM53.1452 80.2018L54.8486 67.0989H58.2553L57.6002 72.209H62.0552L62.7103 67.0989H66.1171L64.4137 80.2018H61.0069L61.6621 74.8296H57.2071L56.5519 80.2018H53.1452Z",
    fill: "#808285"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_69_3967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74.9487,
    height: 79.4037,
    fill: "white",
    transform: "translate(0.0783691 0.798096)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZenithBank);
export default __webpack_public_path__ + "static/media/Zenith-bank.3fa214246f6b6f93e7a7da00f2cc67d2.svg";
export { ForwardRef as ReactComponent };